<template>
  <div class="race-question">
    <sweet-modal ref="question" v-on:close="onClose">
    <div class="image">
      <i class="fa-solid fa-circle-question"></i>
      <h1>Today's Question</h1>
    </div>
    <div>
      <textarea v-model="question" id="Question" maxlength="255" name="question" Placeholder="enter your question here"></textarea>
    </div>
    <div>
      <button class="btn btn--primary"  v-on:click="isquestionId?Update(question):Save(question)" :disabled= "isClicked">{{button}}</button>
    </div>
    </sweet-modal>

  </div>
</template>

<script>
  import {
    SweetModal
  } from 'sweet-modal-vue'
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import {
    db
  } from '../../../firebase'

  // import ListRace from '@/components/Races/List'

  export default {
    name: 'race-question',
    data: () => ({
     question: '',
     isquestionId: false,
     isSaved:false,
     button:'',
     isClicked:false
    }),
    props:{
      show:false,
      todayQuestion:{},
      raceId:null
    // },
    // computed: {
    //   show: {
    //     // getter
    //     get: function() {
    //       return this.showMe
    //     },
    //     // setter
    //     set: function(newValue) {
    //       console.log(newValue)
    //       if (newValue)
    //         this.$refs.question.open()
    //     }
    //   }
    },

    mounted() {
        //this.$parent.$emit('closed', true)
    },
    computed: {
      ...mapGetters({
        race: 'Race/race',
        questions: 'RaceQuestion/raceQuestion'
      })
    },
    // firebase: {
    //   ${this.$fbDbEntry}: db.ref('${this.$fbDbEntry}')
    // },
    methods: {
      onClose() {
        this.$parent.$emit('closed', true)
        this.$emit('saved', true)
      },
      Save: function(question){
         this.isClicked = true
            var raceQuestion = {
              question:question,
              race: {
                id: this.raceId
              }
            }
            this.createRaceQuestion(raceQuestion)
              .then(() => {
                this.isSaved = true
                  var obj = {
                    id: this.raceId,
                    val: true
                  }
                this.$emit('saved', obj)
                this.$refs.question.close()
                this.isClicked = false

              })
              .catch(() => {
                 console.log('failed')
              })

      },
      Update: function(question){
        this.isClicked = true
            var raceQuestion = {
              id: this.todayQuestion.id,
              question:question,
              raceQuestionType: this.todayQuestion.raceQuestionType,
              race: {
                id: this.raceId
              }
            }
            this.updateRaceQuestion(raceQuestion)
              .then(() => {
                // this.$firebaseRefs.${this.$fbDbEntry}.child(this.$route.params.raceId).update({
                //   'standBy': true
                // })
                 var obj = {
                    id: this.raceId,
                    val: true
                  }
                  this.$emit('saved', obj)
                this.$refs.question.close()
                 this.isClicked = false

              })
              .catch(() => {
                 console.log('failed')
              })

      },
      ...mapActions({
        createRaceQuestion: 'RaceQuestion/createOne',
        updateRaceQuestion: 'RaceQuestion/updateOne'
      })
    },

    watch: {
      show(oldVal, newVal) {
        if (this.show)
          this.$refs.question.open()
          this.question = this.todayQuestion.question
          if(this.todayQuestion.id){
            this.isquestionId = true
            this.button = 'Update'
          }else{
            this.isquestionId = false
            this.button = 'Save'
          }
      }
    },
    Save () {
    },
    created() {
      this.$watch('show', function (val) {
      })
    },
    components: {
      SweetModal
    }
  }
</script>
<style>
.race-question .sweet-modal-overlay{
    z-index: 998;
}
</style>



// WEBPACK FOOTER //
// Question.vue?4fa49b4e